/*
 * iurop-anim — animaciones sutiles reutilizables (Kawaicafe).
 *
 * Se activa por atributo en la raiz de una seccion, sin tocar el markup interno:
 *   data-kw-anim              -> enciende el modulo en esa seccion
 *   data-kw-anim-items="sel"  -> elementos que aparecen al entrar en pantalla
 *   data-kw-anim-decos="sel"  -> decoraciones con flotado suave en bucle
 *
 * Reglas de la casa que respeta:
 *  · prefers-reduced-motion: no hace NADA (ni oculta ni anima).
 *  · Los elementos solo se ocultan cuando el JS ya esta listo (clase kw-anim en
 *    la raiz), asi que sin JS la pagina se ve entera.
 *  · Anima la propiedad `translate`, NO `transform`: las tarjetas inclinadas y
 *    las decoraciones ya llevan `transform: rotate(...)` y se perderia.
 *  · Deteccion por BARRIDO de rects ademas de IntersectionObserver (IO no
 *    dispara con ancestros overflow:clip ni en pestana oculta).
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.kwAnimInit) return;
    root.dataset.kwAnimInit = '1';
    if (REDUCE) return;

    var itemsSel = root.getAttribute('data-kw-anim-items');
    var decosSel = root.getAttribute('data-kw-anim-decos');

    var items = itemsSel ? [].slice.call(root.querySelectorAll(itemsSel)) : [];
    // Escalonado POR HERMANOS: una tarjeta suelta no espera por su posicion en
    // el documento; una fila de tres si entra en cascada.
    var seen = new Map();
    items.forEach(function (el) {
      var p = el.parentElement;
      var k = seen.get(p) || 0;
      seen.set(p, k + 1);
      el.setAttribute('data-kw-sr', '');
      el.style.setProperty('--kw-sr-delay', Math.min(k, 4) * 80 + 'ms');
    });

    if (decosSel) {
      [].slice.call(root.querySelectorAll(decosSel)).forEach(function (el, i) {
        el.setAttribute('data-kw-bob', '');
        el.style.setProperty('--kw-bob-delay', (i % 5) * -1.3 + 's');
        el.style.setProperty('--kw-bob-dur', (5.4 + (i % 3) * 0.9).toFixed(1) + 's');
      });
    }

    root.classList.add('kw-anim');

    var pending = items.slice();
    function reveal(el) {
      el.classList.add('is-inview');
      var i = pending.indexOf(el);
      if (i >= 0) pending.splice(i, 1);
    }
    function sweep() {
      if (!pending.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending.slice().forEach(function (el) {
        var r = el.getBoundingClientRect();
        // Solo el eje VERTICAL: las tarjetas de un carrusel horizontal estan
        // fuera de pantalla a la derecha y deben aparecer igual.
        if (r.top < vh - 40 && r.bottom > 0) reveal(el);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      pending.forEach(function (el) { io.observe(el); });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sweep(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', sweep);
    sweep();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kw-anim]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
